import axios from "axios";
import { getCookie } from "../utils/cookieUtils";
import { authNotAdminAlert } from "../utils/alert/authAlert";

const axiosInstance = axios.create({
  baseURL: "https://jas.jaen.kr/api/v1",
  // baseURL: "http://localhost:28080/api/v1",	
  //baseURL: "http://27.232.122.203:28080/api/v1", // 서버 URL
  // baseURL: "http://172.30.1.252:28080/api/v1", // 서버 사내 URL
  // baseURL: "http://172.30.1.77:28080/api/v1", // 테스트(웅렬) URL
  timeout: 20000, // 요청 제한 시간 (20초)
  headers: {
    "Content-Type": "application/json",
  },
});

// 요청 인터셉터 추가 (토큰 추가)
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getCookie("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터 추가 (에러 처리)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API 에러:", error.response?.data || error.message);
    console.log(error);

    if (error?.status === 403) {
      authNotAdminAlert();
    }
    // authNotAdminAlert(); //임시
    return Promise.reject(error);
  }
);

export default axiosInstance;
